import { css } from '@emotion/css';

import { BREAKPOINT_QUERIES } from '@lyearn/core/hooks/useScreen';

export const COMMON_CARD_CLASSNAME =
  'relative bg-bg-primary border border-border rounded-16 group overflow-hidden hover:shadow-02 xs:hover:shadow-none';

export function getSizeValue(value: number | string) {
  return typeof value === 'string' ? `${value} !important;` : `${value}rem !important;`;
}

export const cardSizeStyles = (size: {
  width: number;
  height?: number;
  maxHeight?: number;
  maxWidth?: number;
}) => css`
  ${size.height ? `height: ${getSizeValue(size.height)}` : ''}
  ${size.maxHeight ? `max-height: ${getSizeValue(size.maxHeight)}` : ''}
  ${size.width ? `width: ${getSizeValue(size.width)}` : ''}
  ${size.maxWidth ? `max-width: ${getSizeValue(size.maxWidth)}` : ''}
`;

export const cardSizeMobileStyles = (size: {
  width: number | string;
  height?: number | string;
}) => {
  if (typeof window !== 'undefined' && window.previewDevice === 'mobile') {
    return css`
      ${size.height ? `height: ${getSizeValue(size.height)}` : ''}
      ${`width: ${getSizeValue(size.width)}`}
    `;
  }
  return css`
    @media ${BREAKPOINT_QUERIES.Mobile} {
      ${size.height ? `height: ${getSizeValue(size.height)}` : ''}
      ${`width: ${getSizeValue(size.width)}`}
    }
  `;
};
